"use client";
import { useEffect, useRef } from "react";
import { useFetchOrdersBySaudiProvince } from "../../../apis/dashboardApis";
import { SAUDI_PROVINCE_MAP } from "../../../utilities/saudiProvinceMap";
import { SummaryPeriod } from "../../../apis/dashboardApis";

declare global {
  interface Window {
    anychart: any;
  }
}

export default function OrderMap({
  summaryType = "Today",
  startDate,
  endDate,
}: {
  summaryType?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) {
  const mapRef = useRef<HTMLDivElement>(null);

  const { data = [], isLoading } = useFetchOrdersBySaudiProvince({
    type: summaryType,
    startDate,
    endDate,
  });

  useEffect(() => {
    if (
      !mapRef.current ||
      isLoading ||
      !window.anychart ||
      !window.anychart.maps?.saudi_arabia
    ) {
      return;
    }

    mapRef.current.innerHTML = "";

    const map = window.anychart.map();
    map.geoData(window.anychart.maps.saudi_arabia);

    const COLORS = [
      "#1F3A5F",
      "#2E5EAA",
      "#4C7FB0",
      "#5F8D4E",
      "#2e2150",
      "#C1A15F",
      "#B07C4F",
      "#9C6B6B",
      "#7B6D8D",
      "#5C6F7B",
      "#8A8F98",
      "#6B8E9B",
      "#3F5C4A",
    ];

    // Format data with explicit fill color
    const formattedData = data
      .map((item, index) => {
        const regionId = SAUDI_PROVINCE_MAP[item.province];
        if (!regionId) {
          console.warn("Province not mapped:", item.province);
          return null;
        }

        return {
          id: regionId,
          value: item.totalOrders,
          name: item.province,
          fill: COLORS[index % COLORS.length],
        };
      })
      .filter(Boolean);

    const baseSeries = map.choropleth(formattedData);

    baseSeries.fill("{%fill}");
    baseSeries.stroke(null);
    baseSeries.selectionMode("none");

    baseSeries.tooltip().titleFormat("{%name}").format("Orders: {%value}");

    const hoverSeries = map.choropleth(formattedData);

    hoverSeries.fill("rgba(0,0,0,0)");
    hoverSeries.stroke("#000000", 4);

    hoverSeries.tooltip(false);

    hoverSeries.normal().stroke("rgba(0,0,0,0)");
    hoverSeries.hovered().stroke("#000000", 4);

    hoverSeries.zIndex(10);

    map.background().fill("#FDF8E5");
    map.container(mapRef.current);
    map.draw();
  }, [data, isLoading]);

  return (
    <div className="rounded-3xl">
      <h2 className="text-xl  font-semibold mb-4">Order Map</h2>

      {/* {isLoading ? (
        <div className="h-[400px] flex items-center justify-center text-gray-500">
          Loading map...
        </div>
      ) : ( */}
      <div
        ref={mapRef}
        className="w-full h-[400px] rounded-3xl overflow-hidden"
      />
      {/* )} */}
    </div>
  );
}
